export enum CloudWordType {
  CensorWhiteList = 'CensorWhiteList',
  SpellWhiteList = 'SpellWhiteList',
}

export enum ImageType {
  Unsplash = 'Unsplash',
}

export enum TicketStatus {
  All = 'All',
  Waiting = 'Waiting',
  Dealing = 'Dealing',
  Closed = 'Closed',
}

export enum TicketPriority {
  Normal = 'Normal',
  High = 'High',
}

export enum TicketCategory {
  Cms = 'Cms',
  Cloud = 'Cloud',
  Theme = 'Theme',
  Extension = 'Extension',
  Other = 'Other',
}

export enum MessageType {
  Text = 'Text',
  Image = 'Image',
  Document = 'Document',
}

export enum HostType {
  Starter = 'Starter',
  Standard = 'Standard',
  Professional = 'Professional',
}

export enum ResourceType {
  Extension = 'Extension',
  Theme = 'Theme',
  HostBuy = 'HostBuy',
  HostRenewal = 'HostRenewal',
  HostUpgrade = 'HostUpgrade',
}

export enum CloudType {
  Free = 'Free',
  Basic = 'Basic',
  Standard = 'Standard',
  Professional = 'Professional',
}

export enum CloudProduct {
  Censor = 'Censor',
  Spell = 'Spell',
  Vod = 'Vod',
  Sms = 'Sms',
  Mail = 'Mail',
}
